import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/workspaces/admin/adminWorkspaceQueryKeys.ts
var t = e("admin-workspaces", {
	list: (e) => ["list", e],
	detail: (e) => ["detail", e],
	members: (e) => ["members", e],
	properties: (e, t) => [
		"properties",
		e,
		t
	],
	propertyStats: (e) => ["property-stats", e]
});
//#endregion
export { t as adminWorkspaceQueryKeys };
